// import logo from './logo.svg';
import "./App.css";
// import Board from "./components/Board";
import Game from "./components/Game";


function App() {
  return (
    <div className="app">
      <div className="container">
        <Game/>
      </div>
    </div>
  );
}

export default App;
